'use client';
import React, { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { PrivacyPolicyProps } from './types';
import Markdown from '@/components/atoms/markdown';
import Typography from '@/components/atoms/typography';

const PrivacyPolicy = ({ privacyPolicyData, isPrivacy }: PrivacyPolicyProps) => {

  const pathname = usePathname();
  const isAuYetiPromotion = pathname?.includes('au/yeti-promotion');
  const isNzYetiPromotion = pathname?.includes('nz/yeti-promotion');
  const ctaTitle = isAuYetiPromotion ? privacyPolicyData?.sections[1]?.cta?.link?.title : null;
  const ctaHref = isAuYetiPromotion ? privacyPolicyData?.sections[1]?.cta?.link?.href : null;

  const title = privacyPolicyData?.sections?.[0]?.section_with_heading_description?.title ?? '';
  const summary = privacyPolicyData?.sections?.[0]?.section_with_heading_description?.description ?? "";
  const [pageLoaded, setPageLoaded] = useState(false);

  useEffect(() => {
    const handleLoad = () => {
      setPageLoaded(true);
    };

    if (document.readyState === 'complete') {
      // Page already loaded (e.g., fast navigation)
      setPageLoaded(true);
    } else {
      // Wait for full load
      window.addEventListener('load', handleLoad);
    }

    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []);
  return (
    <div className={`flex ${!pageLoaded && "mt-[181px]"} justify-center ${isPrivacy ? 'privacy' : 'termsOfUse'}`}>
      <div className="flex flex-col items-center px-[36px] lg:px-[90px] py-[18px]">
        {title && (
          <Typography
            className="pb-3 text-[24px] lg:text-[48px] !font-medium  leading-10 text-gray-700 text-center"
          >
            {title}
          </Typography>
        )}

        <Markdown
          targetBlank={isAuYetiPromotion || isNzYetiPromotion}
          className='text-primary-black [&>p]:my-3 [&>ul]:list-disc [&>ul]:ml-20 [&>ul>li]:my-3 [&>ul>li>p>a]:!text-blue [&>p>a]:!text-[#0000FF] [&>a]:!text-[#0000FF] text-14 md:text-16 2xl:text-18'
        >
          {summary}
        </Markdown>
        
        {isAuYetiPromotion && ctaTitle && ctaHref && (
          <div className="mt-6">
            <a
              href={ctaHref as string}
              className="inline-block bg-black !text-white font-medium px-6 py-3 rounded hover:bg-gray-800 transition"
              style={{ color: '#ffffff' }}
            >
              {ctaTitle}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
